import type { ReactElement, ReactNode } from 'react'

import Titlecontent from './Titlecontent'
import Grediantbutton from './Grediantbutton'

interface CtasectionProps {
  bg?: string
  padding?: string
  paddinginner?: string
  title: ReactNode
  content?: ReactNode
  text: ReactNode
  link?: string
  image?: string
}

export default function Ctasection({
  bg = 'bg-white',
  padding = 'top-bottom',
  paddinginner = 'top-bottom',
  title,
  content,
  text,
  link,
  image,
}: CtasectionProps): ReactElement {
  return (
    <section className={`${bg} ${padding}`}>
      <div className="container mx-auto">
        <div
          className={`relative m-auto flex w-full max-w-[1144px] flex-col items-center justify-center overflow-hidden rounded-3xl text-center ${paddinginner}`}
        >
          {/* Background image */}
          {image && (
            <img
              src={image}
              alt={
                typeof title === 'string'
                  ? title
                  : 'CTA background'
              }
              className="absolute inset-0 h-full w-full rounded-3xl object-cover object-center"
            />
          )}

          {/* Content */}
          <div className="z-[1] max-w-[350px] md:max-w-3xl">
            <Titlecontent
              title={title}
              content={content}
            />
          </div>

          {/* CTA Button */}
          <div className="z-[1] pt-8">
            <Grediantbutton
              btntext={text}
              link={link}
              variant="black"
            />
          </div>
        </div>
      </div>
    </section>
  )
}
